import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useFeatureEnabled } from "@/hooks/useFeatureToggle";

const WHATSAPP_NUMBER = "212647424567";

export const WhatsAppFAB = () => {
  const { enabled, loading } = useFeatureEnabled("whatsapp_fab");

  if (loading || !enabled) return null;

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi, I'm interested in your products!")}`;

  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-4 z-50 w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/30 hover:scale-110 transition-transform" style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </motion.a>
  );
};
